import { render, staticRenderFns } from "./Overlay.vue?vue&type=template&id=32ff284a&scoped=true&"
import script from "./Overlay.vue?vue&type=script&lang=ts&"
export * from "./Overlay.vue?vue&type=script&lang=ts&"
import style0 from "./Overlay.vue?vue&type=style&index=0&id=32ff284a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32ff284a",
  null
  
)

export default component.exports